var exports = {
  "wx": "xcc377c0b--2d080a--header",
  "vn": "xcc377c0b--2d080a--header-aside",
  "DB": "xcc377c0b--2d080a--compilations",
};

module.exports = exports;
